<template>
  <div class="news-detail">
    <div style="background: #fff;padding:12px 24px;margin-top: 16px;">
      <div class="title">{{this.detail.title}}</div>
      <div class="date" v-if="this.detail.createTime">{{formatDate(this.detail.createTime)}}</div>
      <div class="content" v-html="this.detail.content"></div>
    </div>

  </div>
</template>
<script>
import { getArticle } from '@/api'
export default {
  data() {
    return {
      detail: {}
    }
  },
  mounted() {
    getArticle({
      id: this.$route.params.id
    }).then(res => {
      this.detail = res.data.data
    })
  },
  methods: {
    formatDate(date) {
      return this.$funcs.dateFormat(date, 'YYYY-mm-dd HH:MM:SS')
    }
  }
}
</script>
<style lang="stylus">
.news-detail
  width 100%
  padding-left: 15px
  padding-right: 15px
  padding-bottom: 60px
  max-width 1366px
  margin 0 auto
  .title
    font-size 18px
    font-weight bold
    color $color-black-85
    margin 0px 0 13px 0
  .date
    bottom 12px
    right 12px
    font-size 14px
    // font-weight bold
    color $color-black-25
  .content
    margin-top 20px
    img
      width 75%
      height auto
      margin 0 auto
</style>

